import CONSTANTS from '~/constants'

export const VARIANT_EDITOR_UI = (storyId: string, variantId: string) =>
  `${CONSTANTS.TRIDENT_ROUTE_COMPOSER_UI}/variant-editor/${storyId}/edit/${variantId}`

export const VARIANT_EDITOR_UI_CREATE = (storyId: string) =>
  `${CONSTANTS.TRIDENT_ROUTE_COMPOSER_UI}/variant-editor/${storyId}`

export const NEW_STORY_EDITOR_UI_ROUTE = () =>
  `${CONSTANTS.TRIDENT_ROUTE_COMPOSER_UI}/story/v2/new`

export const NEW_STORY_WITH_TEMPLATE_EDITOR_UI_ROUTE = (templateId: string) =>
  `${CONSTANTS.TRIDENT_ROUTE_COMPOSER_UI}/story/v2/new?template=${templateId}`

export const EDIT_STORY_EDITOR_UI_ROUTE = (storyId: string) =>
  `${CONSTANTS.TRIDENT_ROUTE_COMPOSER_UI}/story/v2/edit/${storyId}`
